module.exports = __webpack_public_path__ + "static/img/52-3.09ab9fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/52-3.jpg
// module id = LX4z
// module chunks = 0